/**
 * Created by Abner Sui on 06/10/2019.
 * Description:
 * Email Digest preview box component
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, HostListener, ViewChild, Renderer2 } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { EmailDigest } from '../../tamalelibs/models/emaildigest.model';
import { catchError, take } from 'rxjs/operators';
import { EmailDigestService } from '../../services/email-digest.service';
import { EmailDigestPreviweBoxActions } from './email-digest.model';
import { businessConstants } from '../../constants/business.constants';

@Component({
    selector: 'email-digest-preview-box',
    templateUrl: './email-digest-preview-box.component.html',
    styleUrls: ['./email-digest-preview-box.component.scss']
})
export class EmailDigestPreviewBoxComponent implements OnInit {

    @ViewChild('htmlContent', { static: false })
    contentElement: any;

    opened = false;
    loading: boolean;
    content: string;
    dialogWidth: number;
    titleName: string;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _emailDigestService: EmailDigestService,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit() {
        this._initWidth(window.innerWidth);
        this._destroySubscriptions.push(
            this._emailDigestService.previewActionSubject$.subscribe(action => this._actionHandler(action)),
        );
    }

    close(event) {
        this.opened = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        this._initWidth(e.target.innerWidth);
    }

    print(event) {
        const frame = this._renderer2.createElement('iframe');
        frame.id = businessConstants.common.printPreviewEmailDigestFrameId;
        this._renderer2.setAttribute(frame, 'name', 'tamele-print-preview-frame');
        this._renderer2.setAttribute(frame, 'style', 'position:absolute;width:1000px;height:1000px;left:-2000px;top:-2000px;');
        this._renderer2.appendChild(document.getElementsByTagName('body').item(0), frame);
        frame.contentWindow.document.write('<html><head><title>Email Digest Preview</title></head><body>');
        frame.contentWindow.document.write(this.contentElement.html);
        frame.contentWindow.document.write('</body></html>');
        const pageStyleSheet = frame.contentWindow.document.createElement('style');
        pageStyleSheet.textContent =
            '@page { size: auto; margin-top: 2mm; } a{color:black} span{color:black !important} td{color:black}';
        frame.contentWindow.document.body.appendChild(pageStyleSheet);
        const _isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        if (_isFireFox) {
            frame.contentWindow.print();
        } else {
            frame.contentDocument.execCommand('print', false, null);
        }
        frame.remove();
    }

    private _actionHandler(action: { type: string, payload: { event: any, data: EmailDigest, open: boolean } }) {
        if (action.payload.open) {
            const tempDigest: EmailDigest = action.payload.data;
            const showTimeZone = tempDigest.minuteOffset === this._emailDigestService.getLocalMinuteOffset() ? '' : tempDigest.scheduler.configuration;
            this.loading = true;
            this.titleName = action.payload.data.name;

            this._emailDigestService.previewById(tempDigest.id, showTimeZone, tempDigest.scheduler.configuration).pipe(
                catchError(e => {
                    return of(null);
                }),
                take(1),
            ).subscribe(res => {
                if (!this.opened) {
                    // ignore reponse when the preview window is closed
                    return;
                }
                if (res) {
                    this.content = this._emailDigestService.removePreviewHtmlTemplateFooter(res);
                }
                this.loading = false;
            });
        }
        if (action.type === EmailDigestPreviweBoxActions.PREVIEW) {
            this.opened = action.payload.open;
        }
    }

    private _initWidth(windowWidth: number) {
        if (open) {
            if (windowWidth <= 768) {
                this.dialogWidth = 600;
            } else if (windowWidth <= 1024) {
                this.dialogWidth = 800;
            } else {
                this.dialogWidth = 1080;
            }
        }
    }

}
